// ─────────────────────────────────────────────────────────────
// nowpay Insight — brand design system
// Palette sourced from the live ksa.nowpay.com stylesheet:
//   #0d5257 (primary dark teal), #004E64 (deep teal), #1a7a7e (mid teal),
//   #f7c948 (gold accent), #66B57C (green), #e8f5f5 (light teal tint).

import { getRegion } from "../../../components/regionWrapper";
import { Region } from "../../../utils/commonInterfaces";

// ─────────────────────────────────────────────────────────────
export const BRAND = {
    teal: '#1a7a7e',
    tealDark: '#0d5257',
    tealDeep: '#004E64',
    tealSoft: '#e8f5f5',
    green: '#66B57C',
    greenDark: '#15803d',
    yellow: '#f7c948',
    yellowLine: '#f7c948',
    amber: '#F5A623',
    slate: '#8e9ca7',
    rose: '#c2578f',
    red: '#d64545',
    blue: '#4a90d9',
    brown: '#a0623d',
    ink: '#0d5257',
    heroGradient: 'linear-gradient(135deg, #1a7a7e 0%, #0d5257 55%, #004E64 100%)',
};

// Segment tabs above the table. Each maps to a backend status by matching the
// live /users/statuses names (kept dynamic — no hard-coded status IDs).
export interface Segment {
    key: string;
    label: string;
    keywords: string[] | null;
}

export const SEGMENTS: Segment[] = [
    { key: 'all', label: 'All', keywords: null },
    { key: 'pending', label: 'Pending', keywords: ['pending'] },
    { key: 'approved', label: 'Approved', keywords: ['approved'] },
    { key: 'inactive', label: 'Inactive', keywords: ['inactive'] },
];

// Allowed suspension reasons to display (case-insensitive matching).
export const allowedReasons = [
    'HR Request',
    'Blocked User',
    'Customer Request',
    'Late Payment',
    'Late payment', // API returns it with lowercase 'p'
    'Employee has other loans',
    'Employee Resigned',
];

export const TRANSACTING_USERS_EXPORT_NUMBER_COLUMNS = [
    'Next Month Due Amount / المبلغ المستحق للشهر القادم',
    'Remaining Outstanding Amounts / المبالغ المتبقية/المستحقة',
    'Total Requested Amount ( Including Cancelled & Processing) / إجمالي المبلغ المطلوب (بما في ذلك الملغى وقيد المعالجة)',
    'Total Requested Amount Transferred (إجمالي المبلغ المطلوب المحوّل)',
    'Paid Amount / المبلغ المدفوع',
    'Early Settlement Amount / مبلغ السداد المبكر',
];

// Compact currency formatting for the hero stat — 1_280_000 → "1.28M", 62_700 → "62.7K".
// Fixes the malformed "62,764.310,000,000,005 SAR" produced by comma-only formatting of a float.
const compactAmountFormatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 2,
});

export const formatCompactCurrency = (num?: number) => {
    const region = getRegion();
    return `${compactAmountFormatter.format(Number(num) || 0)} ${region === Region.SE ? 'SAR' : 'EGP'}`;
}
